import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";

const TakeoverPropertyOwnership = ({ takeoverPropOwnerList }) => {

    const takeoverPropertyOwnershipColumns = [
      {
        field: "internalapplicationid",
        headerName: "Internal Application ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "ownershipId",
        headerName: "Ownership ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "ownership",
        headerName: "Ownership",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "ownershipDtlsId",
        headerName: "Ownership Details ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "internalCustomerId",
        headerName: "Internal Customer ID",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "titleHolderName",
        headerName: "Title Holder Name",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "createdBy",
        headerName: "Created By",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "modifiedBy",
        headerName: "Modified By",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
      },
      {
        field: "createdDate",
        headerName: "Created Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>
          convertDateWithValidation(params.row.createdDate),
      },
      {
        field: "modifiedDate",
        headerName: "Modified Date",
        headerAlign: "center",
        align: "center",
        flex: 200,
        type: "string",
        editable: false,
        valueGetter: (params) =>
          convertDateWithValidation(params.row.modifiedDate),
      },
    ];

    return(
        <AccordianContainer
        id="accord"
        title="TakeOver Property Ownership"
        initialOpen={false}
       >
        <Box sx={{ marginTop: "-0.5%" }}>
        <CustomDataGrid
          noDataMessage="No Data"
          rows={validate(takeoverPropOwnerList) ?
            takeoverPropOwnerList.map((item, index) => ({
              id: index + 1,
              ...item,
            })) : []}
          columns={takeoverPropertyOwnershipColumns}
          pageSize={15}
          pageSizeOptions={[10]}
          gridLazyLoad={() => {}}
          gridHeight={305}
          getRowId={(row) => row.ownershipId}
          onCellKeyDown={(event, param) => {
            (param.key === "e" || param.key === "E") &&
              param.preventDefault();
          }}
        />
        </Box>
        </AccordianContainer>
    );
}

export default TakeoverPropertyOwnership;